"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VALID_MANIFEST_EXTENSIONS = void 0;
exports.isValidManifestFileType = isValidManifestFileType;
const file_utils_1 = require("./file-utils");
exports.VALID_MANIFEST_EXTENSIONS = ['.json'];
function isValidManifestFileType(filename) {
    const name = filename.toLowerCase();
    const extension = (0, file_utils_1.getFileExtension)(name);
    return exports.VALID_MANIFEST_EXTENSIONS.includes(extension);
}
//# sourceMappingURL=is-valid-manifest-file-type.js.map